import React from 'react';
import '../css/BSSIDsDetailsRate.css'; // 导入样式文件
import BSSIDsIcon from '../svg/BSSIDs.svg';
import backIcon from '../svg/back.svg'; 

const BssidsDetailsRate = ({ selectedBSSID, onReturn }) => {
  return (
      <div className="rate-container">
      <div className="rate-header">
          <img src={BSSIDsIcon} alt="BSSID Icon" className="bssid-icon" />
          <div className="bssid-title">{selectedBSSID.ap_best_name_formatted}</div>
      </div>
      <div className="rate">BSSID</div>
      <div className="rate-section">
          <div className="rate-subtitle">速率 (Mbps)</div>
          <div className="rate-text">支持速率集: {selectedBSSID.apData.supported_rates.join(', ')}</div>
          <div className="rate-text">基本速率集: {selectedBSSID.apData.basic_rates.join(', ')}</div>
      </div>
      <div className="rate-section">
          <div className="rate-subtitle">国家代码: {selectedBSSID.apData.country_code}</div>
      </div>

      {selectedBSSID?.apData?.n_max_tx_rate && (
        <div className="rate-section" id="80211n">
          <div className="rate-subtitle">802.11n 能力</div>
          <div className="rate-text">SGI 20 MHz: {String(selectedBSSID.apData.n_sgi_20mhz)}</div>
          <div className="rate-text">SGI 40 MHz: {String(selectedBSSID.apData.n_sgi_40mhz)}</div>
          <div className="rate-text">Max AMPDU: {selectedBSSID.apData.n_max_ampdu} bytes</div>
          <div className="rate-table">
              <div className="table-row">
                  <div className="table-cell"></div>
                  <div className="table-cell">Tx</div>
                  <div className="table-cell">Rx</div>
              </div>
              <div className="table-row">
                  <div className="table-cell">Max Rate</div>
                  <div className="table-cell">{(selectedBSSID.apData.n_max_tx_rate_kbps / 1000).toFixed(1)} Mbps</div>
                  <div className="table-cell">{(selectedBSSID.apData.n_max_rx_rate_kbps / 1000).toFixed(1)} Mbps</div>
              </div>
              <div className="table-row">
                  <div className="table-cell">Max Streams</div>
                  <div className="table-cell">{selectedBSSID.apData.n_max_tx_streams}</div>
                  <div className="table-cell">{selectedBSSID.apData.n_max_rx_streams}</div>
              </div>
              <div className="table-row">
                  <div className="table-cell">Max MCS</div>
                  <div className="table-cell">{selectedBSSID.apData.n_max_tx_mcs}</div>
                  <div className="table-cell">{selectedBSSID.apData.n_max_rx_mcs}</div>
              </div>
          </div>
      </div>
      )}

      {selectedBSSID?.apData?.ac_max_tx_mcs && (
      <div className="rate-section" id="80211ac">
      <div className="rate-subtitle">802.11ac 能力</div>
      <div className="rate-text">SGI 80 MHz: {String(selectedBSSID.apData.ac_sgi_80mhz)}</div>
      <div className="rate-text">SGI 160 MHz: {String(selectedBSSID.apData.ac_sgi_160mhz)}</div>
      <div className="rate-text">Max AMPDU: {selectedBSSID.apData.ac_max_ampdu} bytes</div>
      <div className="rate-text">MU Beamformer: {selectedBSSID?.apData?.ac_multi_user_beam === 1 ? 'true' : 'false'}</div>
      <div className="rate-table">
          <div className="table-row">
              <div className="table-cell"></div>
              <div className="table-cell">Tx</div>
              <div className="table-cell">Rx</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max Rate</div>
              <div className="table-cell">{(selectedBSSID.apData.ac_max_tx_rate_kbps / 1000).toFixed(1)} Mbps</div>
              <div className="table-cell">{(selectedBSSID.apData.ac_max_rx_rate_kbps / 1000).toFixed(1)} Mbps</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max Streams</div>
              <div className="table-cell">{selectedBSSID.apData.ac_max_tx_streams}</div>
              <div className="table-cell">{selectedBSSID.apData.ac_max_rx_streams}</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max MCS</div>
              <div className="table-cell">{selectedBSSID.apData.ac_max_tx_mcs}</div>
              <div className="table-cell">{selectedBSSID.apData.ac_max_rx_mcs}</div>
          </div>
      </div>
  </div>
      )}
      {selectedBSSID?.apData?.ax_capabilities && (
      <div className="rate-section" id="80211ax">
      <div className="rate-subtitle">802.11ax 能力</div>
      <div className="rate-text">Max AMPDU: {selectedBSSID.apData.ax_capabilities.max_ampdu} bytes</div>
      <div className="rate-text">MU Beamformer: {String(selectedBSSID.apData.ax_capabilities.su_beamformer)}</div>
      <div className="rate-text">MU Beamformee: {String(selectedBSSID.apData.ax_capabilities.su_beamformee)}</div>
      <div className="rate-text">SU Beamformer: {String(selectedBSSID.apData.ax_capabilities.mu_beamformer)}</div>
      <div className="rate-table">
          <div className="table-row">
              <div className="table-cell"></div>
              <div className="table-cell">Tx</div>
              <div className="table-cell">Rx</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max Rate</div>
              <div className="table-cell">{(selectedBSSID.apData.ax_capabilities.max_tx_rate_kbps / 1000).toFixed(1)} Mbps</div>
              <div className="table-cell">{(selectedBSSID.apData.ax_capabilities.max_tx_rate_kbps / 1000).toFixed(1)} Mbps</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max Streams</div>
              <div className="table-cell">{selectedBSSID.apData.ax_capabilities.max_tx_streams}</div>
              <div className="table-cell">{selectedBSSID.apData.ax_capabilities.max_rx_streams}</div>
          </div>
          <div className="table-row">
              <div className="table-cell">Max MCS</div>
              <div className="table-cell">{selectedBSSID.apData.ax_capabilities.max_tx_mcs}</div>
              <div className="table-cell">{selectedBSSID.apData.ax_capabilities.max_rx_mcs}</div>
          </div>
      </div>
      <div className="rate-subtitle">高级 802.11ax 能力</div>
      <div className="rate-text">+HTC HE Support: {String(selectedBSSID.apData.ax_capabilities.htc_he)}</div>
<div className="rate-text">TWT Requester 支持: {String(selectedBSSID.apData.ax_capabilities.twt_requester)}</div>
<div className="rate-text">TWT Responder 支持: {String(selectedBSSID.apData.ax_capabilities.twt_responder)}</div>
<div className="rate-text">切片支持: {selectedBSSID.apData.ax_capabilities.fragmentation_level}</div>
<div className="rate-text">HE Link Adaptation 支持: {selectedBSSID.apData.ax_capabilities.he_link_adaptation}</div>
<div className="rate-text">所有 ACK 支持: {String(selectedBSSID.apData.ax_capabilities.all_ack)}</div>
<div className="rate-text">BSR 支持: {String(selectedBSSID.apData.ax_capabilities.bsr)}</div>
<div className="rate-text">广播 TWT 支持: {String(selectedBSSID.apData.ax_capabilities.broadcast_twt)}</div>
<div className="rate-text">32-bit BA Bitmap 支持: {String(selectedBSSID.apData.ax_capabilities.has_32_bit_ba_bitmap)}</div>
<div className="rate-text">MU Cascading 支持: {String(selectedBSSID.apData.ax_capabilities.mu_cascading)}</div>
<div className="rate-text">Ack-Enabled 汇聚支持: {String(selectedBSSID.apData.ax_capabilities.ack_enabled_aggregation)}</div>
<div className="rate-text">OM 控制支持: {String(selectedBSSID.apData.ax_capabilities.om_control)}</div>
<div className="rate-text">OFDMA RA 支持: {String(selectedBSSID.apData.ax_capabilities.ofdma_ra)}</div>
<div className="rate-text">Maximum A-MPDU Length Exponent Extension: {selectedBSSID.apData.ax_capabilities.amsdu_fragmentation}</div>
<div className="rate-text">灵活 TWT 计划支持: {String(selectedBSSID.apData.ax_capabilities.flexible_twt_schedule)}</div>
<div className="rate-text">QTP 支持: {String(selectedBSSID.apData.ax_capabilities.qtp)}</div>
<div className="rate-text">BQR 支持: {String(selectedBSSID.apData.ax_capabilities.bqr)}</div>
<div className="rate-text">SRP Responder: {String(selectedBSSID.apData.ax_capabilities.srp_responder)}</div>
<div className="rate-text">NDP 反馈报告: {String(selectedBSSID.apData.ax_capabilities.ndp_feedback_report)}</div>
<div className="rate-text">OPS 支持: {String(selectedBSSID.apData.ax_capabilities.ops)}</div>
<div className="rate-text">A-MSDU in A-MPDU: {String(selectedBSSID.apData.ax_capabilities.amsdu_in_ampdu)}</div>
<div className="rate-text">HE Subchannel Selective Transmission: {String(selectedBSSID.apData.ax_capabilities.he_subchannel_selective_tx)}</div>
<div className="rate-text">UL 2x996-tone RU 支持: {String(selectedBSSID.apData.ax_capabilities.ul_2x996_tone_ru)}</div>
<div className="rate-text">OM 控制上行 MU 数据禁用 RX: {String(selectedBSSID.apData.ax_capabilities.om_control_ul_mu_data_disable_rx)}</div>
<div className="rate-text">40 MHz in 2.4 GHz: {String(selectedBSSID.apData.ax_capabilities.has_40_mhz_in_2g)}</div>
<div className="rate-text">40 MHz/80 MHz in 5 GHz: {String(selectedBSSID.apData.ax_capabilities.has_40_80_mhz_in_5g)}</div>
<div className="rate-text">160 MHz in 5 GHz: {String(selectedBSSID.apData.ax_capabilities.has_160_mhz_in_5g)}</div>
<div className="rate-text">160/80+80 MHz in 5 GHz: {String(selectedBSSID.apData.ax_capabilities.has_160_80_80_mhz_in_5g)}</div>
<div className="rate-text">242-tone RUs in 2.4 GHz: {String(selectedBSSID.apData.ax_capabilities.ru_mapping_in_2g)}</div>
<div className="rate-text">242-tone RUs in 5 GHz: {String(selectedBSSID.apData.ax_capabilities.ru_mapping_in_5g)}</div>
<div className="rate-text">80 MHz preamble; secondary 20 MHz punctured: {String(selectedBSSID.apData.ax_capabilities.preamble_puncturing_rx_20_mhz_secondary)}</div>
<div className="rate-text">80 MHz preamble; one 20 MHz subchannel in secondary 40 MHz punctured: {String(selectedBSSID.apData.ax_capabilities.preamble_puncturing_rx_one_20_mhz_in_secondary_40_mhz)}</div>
<div className="rate-text">160 MHz/80+80 MHz preamble; secondary 20 MHz punctured in primary 80 MHz: {String(selectedBSSID.apData.ax_capabilities.preamble_puncturing_primary_80_mhz_secondary_20_mhz)}</div>
<div className="rate-text">160 MHz/80+80 MHz preamble; primary 40 MHz present in primary 80 MHz: {String(selectedBSSID.apData.ax_capabilities.preamble_puncturing_primary_40_mhz_present)}</div>
<div className="rate-text">LDPC Coding in Payload: {String(selectedBSSID.apData.ax_capabilities.ldcp_coding_in_payload)}</div>
<div className="rate-text">HE SU PPDU w/1x HE-LTF, 0.8 us GI: {String(selectedBSSID.apData.ax_capabilities.he_ltf_and_gi_for_he_ppdus)}</div>
<div className="rate-text">Midamble Tx/Rx Max NSTS: {selectedBSSID.apData.ax_capabilities.midamble_tx_rx_max_nsts}</div>
<div className="rate-text">Full Bandwidth UL MU-MIMO: {String(selectedBSSID.apData.ax_capabilities.uplink_mu_mimo_to_ap_full_bw)}</div>
<div className="rate-text">Partial Bandwidth UL MU-MIMO: {String(selectedBSSID.apData.ax_capabilities.uplink_mu_mimo_to_ap_partial_bw)}</div>
<div className="rate-text">Rx HE MU PPDU From Non-AP STA: {String(selectedBSSID.apData.ax_capabilities.ul_he_mu_ppdu_payload)}</div>
<div className="rate-text">SU Beamformer: {String(selectedBSSID.apData.ax_capabilities.su_beamformer)}</div>
<div className="rate-text">SU Beamformee: {String(selectedBSSID.apData.ax_capabilities.su_beamformee)}</div>
<div className="rate-text">MU Beamformer: {String(selectedBSSID.apData.ax_capabilities.mu_beamformer)}</div>
<div className="rate-text">Beamformee STS≤80 MHz: {selectedBSSID.apData.ax_capabilities.beamformee_sts_over_80_mhz}</div>
<div className="rate-text">Beamformee STS＞80 MHz: {selectedBSSID.apData.ax_capabilities.beamformee_sts_up_to_80_mhz}</div>
<div className="rate-text">Sounding Dimensions≤80 MHz: {selectedBSSID.apData.ax_capabilities.sounding_dimensions_over_80_mhz}</div>
<div className="rate-text">Sounding Dimensions＞80 MHz: {selectedBSSID.apData.ax_capabilities.sounding_dimensions_up_to_80_mhz}</div>
<div className="rate-text">Ng =16 SU Feedback: {String(selectedBSSID.apData.ax_capabilities.ng_16_for_su_feedback)}</div>
<div className="rate-text">Ng =16 MU Feedback: {String(selectedBSSID.apData.ax_capabilities.ng_16_for_mu_feedback)}</div>
<div className="rate-text">Codebook Size(ф,ψ)= [4,2] SU 反馈: {String(selectedBSSID.apData.ax_capabilities.codebook_size_4_2_for_su_feedback)}</div>
<div className="rate-text">Codebook Size(ф,ψ)= [7,5] MU 反馈: {String(selectedBSSID.apData.ax_capabilities.codebook_size_7_5_for_mu_feedback)}</div>
<div className="rate-text">触发 SU Beamforming 反馈: {String(selectedBSSID.apData.ax_capabilities.beamforming_feedback_su)}</div>
<div className="rate-text">触发 MU Beamforming Partial BW 反馈: {String(selectedBSSID.apData.ax_capabilities.beamforming_feedback_mu)}</div>
<div className="rate-text">触发 CQI 反馈: {String(selectedBSSID.apData.ax_capabilities.beamforming_feedback_cqi_only)}</div>
<div className="rate-text">部分带宽扩展范围: {String(selectedBSSID.apData.ax_capabilities.extended_range_on_partial_bw)}</div>
<div className="rate-text">PPE Threshold Present: {String(selectedBSSID.apData.ax_capabilities.ppe_threshold_present)}</div>
<div className="rate-text">SRP-based SR: {String(selectedBSSID.apData.ax_capabilities.srp_based_sr)}</div>
<div className="rate-text">Power Boost Factor: {selectedBSSID.apData.ax_capabilities.power_boost_factor}</div>
<div className="rate-text">HE SU PPDU, HE MU PPDU w/4x HE-LTF, 0.8 us GI: {String(selectedBSSID.apData.ax_capabilities.has_4x_he_ltf_short_gi_he_su_ppdu)}</div>
<div className="rate-text">Max NC: {selectedBSSID.apData.ax_capabilities.max_nc}</div>
<div className="rate-text">HE ER SU PPDU w/4x HE-LTF, 0.8 us Gl: {String(selectedBSSID.apData.ax_capabilities.he_er_su_ppdu_4x_he_ltf_short_gi)}</div>
<div className="rate-text">HE ER SU PPDU w/1x HE-LTF, 0.8 us GI: {String(selectedBSSID.apData.ax_capabilities.he_er_su_ppdu_1x_he_ltf_short_gi)}</div>
<div className="rate-text">Midamble Tx/Rx 2x,1x HE-LTF: {String(selectedBSSID.apData.ax_capabilities.midamble_tx_rx_2x_1x_he_ltf)}</div>
<div className="rate-text">DCM Max BW: {selectedBSSID.apData.ax_capabilities.dcm_max_bw}</div>
<div className="rate-text">16 HE SIG-B OFDM Symbols 支持: {String(selectedBSSID.apData.ax_capabilities.longer_than_16_he_sigb_ofdm_symbols)}</div>
<div className="rate-text">非触发 CQI 反馈: {String(selectedBSSID.apData.ax_capabilities.non_triggered_cqi_feedback)}</div>
<div className="rate-text">Rx Full BW SU Using HE MU PPDU w/Compressed SIGB: {String(selectedBSSID.apData.ax_capabilities.rx_full_bw_su_using_he_mu_ppdu_compressed_sigb)}</div>
<div className="rate-text">Rx Full BW SU Using HE MU PPDU w/Non-Compressed SIGB: {String(selectedBSSID.apData.ax_capabilities.rx_full_bw_su_using_he_mu_ppdu_non_compressed_sigb)}</div>

  </div>
      )}



      <img className="back-button" src={backIcon} alt="Back" onClick={onReturn} />
  </div>
    );
};

export default BssidsDetailsRate;